import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/modalRelatorios.css"; // Importação do CSS

function ModalRelatorios({ projetoId, onClose }) {
  const [relatorios, setRelatorios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    // Simulando delay para ver o loading (opcional, pode remover depois)
    axios
      .get(`/api/relatorios/${projetoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setRelatorios(res.data.Result || []);
      })
      .catch(() => setRelatorios([]))
      .finally(() => setLoading(false));
  }, [projetoId]);

  return (
    <div
      className="modal fade show modal-overlay-custom"
      tabIndex="-1"
      role="dialog"
      onClick={onClose} // Fecha ao clicar fora (opcional, boa UX)
    >
      <div 
        className="modal-dialog modal-lg modal-dialog-centered"
        onClick={e => e.stopPropagation()} // Impede que o clique dentro do modal feche ele
      >
        <div className="modal-content modal-content-custom">
          {/* Header */}
          <div className="modal-header modal-header-custom d-flex justify-content-between align-items-center">
            <h5 className="modal-title-custom mb-0">Relatórios do Projeto</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body-scroll">
            {loading ? (
              <div className="state-message">
                <div className="spinner-border text-primary mb-2" role="status"></div>
                <div>Carregando históricos...</div>
              </div>
            ) : relatorios.length === 0 ? (
              <div className="state-message">
                <i className="bi bi-inbox fs-2 mb-2 d-block"></i> {/* Ícone opcional se usar Bootstrap Icons */}
                Nenhum relatório encontrado para este projeto.
              </div>
            ) : (
              <div className="row g-3">
                {relatorios.map((r) => (
                  <div className="col-12" key={r.id}>
                    <div className="report-card p-3">
                      
                      {/* Linha de Título e Data */}
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <h6 className="report-title mb-0">{r.etapa}</h6>
                        <span className="report-date badge bg-light text-secondary border">
                          {r.data_obs
                            ? new Date(r.data_obs).toLocaleDateString()
                            : "-"}
                        </span>
                      </div>

                      {/* Conteúdo do Relatório */}
                      <div className="mb-2">
                        <span className="report-label">Situação:</span>
                        <span className="report-value fw-medium">{r.situacao_etapa}</span>
                      </div>
                      
                      <div className="mb-2">
                        <span className="report-label">Observação:</span>
                        <span className="report-value d-block mt-1 text-muted">
                          {r.observacao || "Sem observações."}
                        </span>
                      </div>

                      {r.inserido_por && (
                        <div className="mt-3 pt-2 border-top">
                          <small className="text-muted d-flex align-items-center">
                            <span className="report-label" style={{ marginBottom: 0 }}>Inserido por:</span>
                            {r.nome_usuario || `(ID: ${r.inserido_por})`}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalRelatorios;